import ColorField from "../../../components/Form/ColorField";
import { useTranslationApp } from "../../../lib/i18next";
import {
  TEMPLATES_PAINT_SETTINGS,
  TEMPLATES_STROKE_METRIC,
  TEMPLATES_STROKE_WIDTH,
} from "../../../i18n/keysTranslations";
import PaintMetricSettings from "./PaintMetricSettings";

const optionalRules = { required: false };
const STROKE_WIDTH_SLIDER_MAX = 24;

const TextStrokeFields = ({
  control,
  errors,
  disabled = false,
  onChangeField,
}) => {
  const { t } = useTranslationApp();
  return (
    <ColorField
      control={control}
      errors={errors}
      name="strokeColor"
      label={t(TEMPLATES_STROKE_WIDTH)}
      fullWidth
      disabled={disabled}
      rules={optionalRules}
      actionsChange={(value) => onChangeField({ key: "strokeColor", value })}
      trailing={
        <PaintMetricSettings
          control={control}
          errors={errors}
          disabled={disabled}
          ariaLabel={t(TEMPLATES_PAINT_SETTINGS)}
          fields={[
            {
              name: "strokeWidth",
              label: t(TEMPLATES_STROKE_METRIC),
              sliderMax: STROKE_WIDTH_SLIDER_MAX,
              onChangeField,
            },
          ]}
        />
      }
    />
  );
};

export default TextStrokeFields;
